import VS from 'constants/ValidationShema';
import getObjectValue from "libs/getObjectValue";

export default () => VS.object({
    step: VS.any().strip(),
    form: VS.lazy(form => {
        const refersTo = getObjectValue("basicData.refersTo", form, null);
        const hasManyObjects = getObjectValue("noticeProcedureSummary.noticeObjectData.noticeHasManyObjects", form, null);

        return VS.object({
            positionIds: VS.any(),
            basicData: VS.object({
                refersTo: VS.string(),
            }),
            purchaserData: VS.object({
                phoneNumber: VS.stringMaxNoRq(100),
                faxNumber: VS.stringMaxNoRq(100),
                email: VS.emailMax(250),
                type: VS.string(),
                typeOther: VS.any().when("type", { is: "1.5", then: VS.stringMax(200), otherwise: VS.any().strip() }),
            }),
            noticeProcedureSummary: VS.object({
                noticeNature: VS.string(),
                precededByContractOrContractIntentionNotice: VS.requiredBoolean(),
                ezamowieniaNumber: VS.any().when("precededByContractOrContractIntentionNotice", { is: (x) => x === true, then: VS.stringMax(20), otherwise: VS.any().strip() }),
                ueFunded: VS.requiredBoolean(),
                ueProgramName: VS.any().when("ueFunded", { is: (x) => x === true, then: VS.stringMax(400), otherwise: VS.any().strip() }),
                orderRealizationType: refersTo === "Order" ? VS.string() : VS.any().strip(),
                frameworkRealizationType: refersTo === "FrameworkAgreement" ? VS.string() : VS.any().strip(),
                orderType: VS.string(),
                orderName: VS.stringMax(200),
                noticeObjectData: VS.object({
                    noticeHasManyObjects: VS.requiredBoolean(),
                    notDivided: VS.any().when("noticeHasManyObjects", {
                        is: (x) => x === false, then: VS.object({
                            orderSubjectDescription: VS.stringMax(10000),
                            mainCpv: VS.requiredObject(),
                            additionalCpv: VS.any(),
                        }), otherwise: VS.any().strip()
                    }),
                    divided: VS.any().when("noticeHasManyObjects", {
                        is: (x) => x === true, then: VS.arrayOfShape({
                            agreementForPosition: VS.requiredBoolean(),
                            orderSubjectDescription: VS.stringMax(10000),
                            mainCpv: VS.requiredObject(),
                            additionalCpv: VS.any(),
                        }), otherwise: VS.any().strip()
                    }),
                })
            }),
            contractData: VS.object({
                notDivided: hasManyObjects === false
                    ? VS.object({
                        contractDate: VS.dateTimeValid(),
                        contractValue: VS.amount(0),
                        contractCurrency: VS.anyRequired(),
                        ezamowieniaNumber: VS.stringMax(20),
                        realizationPeriod: VS.string(),
                        realizationPeriodDateFrom: VS.any().when("realizationPeriod", {
                            is: "DateFromTo",
                            then: VS.dateTimeValid(),
                            otherwise: VS.any().strip()
                        }),
                        realizationPeriodDateTo: VS.any().when("realizationPeriod", {
                            is: (x) => x === "DateFromTo" || x === "DateTo",
                            then: VS.dateTimeValid(),
                            otherwise: VS.any().strip()
                        }),
                        realizationPeriodAmount: VS.any().when("realizationPeriod", {
                            is: (x) => x === "NumberOfDays" || x === "NumberOfMonths",
                            then: VS.string(),
                            otherwise: VS.any().strip()
                        }),
                        contractorName: VS.stringMax(300),
                        otherContractorNames: VS.stringMaxNoRq(1000),
                        street: VS.stringMaxNoRq(100),
                        city: VS.stringMax(100),
                        postCode: VS.stringMaxNoRq(20),
                        state: VS.any().when("country", {
                            is: "PL",
                            then: VS.string(),
                            otherwise: VS.any().strip()
                        }),
                        country: VS.string(),
                        nip: VS.stringMaxNoRq(100),
                    })
                    : VS.any().strip(),

                divided: hasManyObjects === true
                    ? VS.arrayOfShape({
                        contractDate: VS.dateTimeValid(),
                        contractValue: VS.amount(0),
                        contractCurrency: VS.anyRequired(),
                        ezamowieniaNumber: VS.stringMax(20),
                        realizationPeriod: VS.string(),
                        realizationPeriodDateFrom: VS.any().when("realizationPeriod", {
                            is: "DateFromTo",
                            then: VS.dateTimeValid(),
                            otherwise: VS.any().strip()
                        }),
                        realizationPeriodDateTo: VS.any().when("realizationPeriod", {
                            is: (x) => x === "DateFromTo" || x === "DateTo",
                            then: VS.dateTimeValid(),
                            otherwise: VS.any().strip()
                        }),
                        realizationPeriodAmount: VS.any().when("realizationPeriod", {
                            is: (x) => x === "NumberOfDays" || x === "NumberOfMonths",
                            then: VS.string(),
                            otherwise: VS.any().strip()
                        }),
                        contractorName: VS.stringMax(300),
                        otherContractorNames: VS.stringMaxNoRq(1000),
                        street: VS.stringMaxNoRq(100),
                        city: VS.stringMax(100),
                        postCode: VS.stringMaxNoRq(20),
                        state: VS.any().when("country", {
                            is: "PL",
                            then: VS.string(),
                            otherwise: VS.any().strip()
                        }),
                        country: VS.string(),
                        nip: VS.stringMaxNoRq(100),
                    })
                    : VS.any().strip(),
            }),
            contractProgress: VS.object({
                contractCompleted: VS.requiredBoolean(),
                contractCompletedDate: VS.dateTimeValid(),
                contractCompletedOnTime: VS.any().when("contractCompleted", {is: (x) => x === true, then: VS.requiredBoolean(), otherwise: VS.any().strip()}),
                totalContractValuePaid: VS.amount(0),
                currencyCode: VS.string(),
                contractFulfilledProperly: VS.requiredBoolean(),
                contractMonitored: VS.string(),
                updateCount: VS.integerMinMax(0, 10),
                contractUpdates: VS.arrayOfShape().when("updateCount", {is: (x) => x > 0, then: VS.arrayOfShape({
                    legalBasisForChanges: VS.string(),
                    changeReasonDescription: VS.stringMax(1000),
                    updatedOrderDescription: VS.stringMax(1000),
                    contractChangeValue: VS.amount(0),
                    currencyCode: VS.string(),
                    priceIncreaseDueToChange: VS.requiredBoolean(),
                }), otherwise: VS.arrayOfShape().strip()}),
            }),
            additionalInfoData: VS.object({
                info: VS.stringMaxNoRq(4000)
            })
        })
    })
})